// Form4.js
import React, { useState, useRef } from 'react';
import ChatBox from '../../custom_elements/ChatBox';
import {CustomInput, validationRules} from '../../custom_elements/CustomInput';
import CustomSelect from '../../custom_elements/CustomSelect';
import CustomCheckbox from '../../custom_elements/CustomCheckbox';

export default function Form4({ nextForm, passGetFormData, passValidateAllFormFields, retrievedFormData = {}, sendChat }) {
    const formRefs = useRef([]);  // Reference array to store refs of CustomInput fields

    const [vorbelastungCount, setVorbelastungCount] = useState(1);

    const getFormData = () => {
        console.log("INSIDE GETFORMDATA on Form4");
        const form = document.getElementById('form4');
        const formData = new FormData(form);
        const data = {};
        for (let [key, value] of formData.entries()) {
            data[key] = value;
        }
        return data;
    };

    React.useEffect(() => {
        console.log('Form4 mounted');
        passGetFormData(() => getFormData); // Pass the getFormData function to the parent
    }, [passGetFormData]);



    const validateAllFormFields = () => {
      console.log("validateAllFormFields in Form4");
      let isValid = true;
console.log(formRefs);
      // Ensure refs are properly populated
      if (formRefs.current.length === 0) {
        console.error("No form refs found!");
        return false;
      }

      // Loop through all form inputs and call validateField on each one
      formRefs.current.forEach(inputRef => {
        if(inputRef != null) {
          console.log("checking ref: ", inputRef);
          // Check if inputRef is defined and properly set
          if (inputRef?.validateField()) {
            console.log("Field is valid:", inputRef?.validateField());
          } else {
            console.warn("Ref is not initialized or validateField failed:", inputRef);
            isValid = false; // Optional: Fail validation if ref is not set or invalid
          }
        }
      });

      return isValid;
    };

    React.useEffect(() => {
        console.log("INSIDE useEffect passValidateAllFormFields on Form4");

        passValidateAllFormFields(() => validateAllFormFields);
    }, [passValidateAllFormFields]);



    return (
        <div className="formFieldBox">
            <a className="toggleButton" style={{cursor: "default"}}>
                BERECHNUNG
            </a>
            <form id="form4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="formFieldContent">
                                <div className="fieldDiv">
                                    <CustomSelect ref={el => formRefs.current[1] = el} label="Kreditlaufzeit*" formData={retrievedFormData} sendChat={sendChat} name="laufzeit" rules={[{ruleKey: "required"}]}>
                                        {[<option key="0" value="0">Standardlaufzeit</option>,
                                        <option key="-1" value="-1">Mindestlaufzeit</option>,
                                        <option key="-2" value="-2">Maximallaufzeit</option>,
                                        <option key="120" value="120">
                                            10 Jahre
                                        </option>,
                                        <option key="180" value="180">
                                            15 Jahre
                                        </option>,
                                        <option key="240" value="240">
                                            20 Jahre
                                        </option>,
                                        <option key="300" value="300">
                                            25 Jahre
                                        </option>,
                                        <option key="360" value="360">
                                            30 Jahre
                                        </option>,
                                        <option key="420" value="420">
                                            über 31 Jahre
                                        </option>,
                                        ]}
                                    </CustomSelect>
                                </div>
                                <div className="fieldDiv">
                                    <CustomSelect ref={el => formRefs.current[2] = el} label="Tilgungsfreier Zeitraum*" formData={retrievedFormData} sendChat={sendChat} name="laufzeit_tilgungsfrei" rules={[{ruleKey: "required"}]}>

                                        {[
                                            // Static options
                                            <option key={0} value={0}>Keiner</option>,
                                            <option key={6} value={6}>6 Monate</option>,
                                            <option key={12} value={12}>12 Monate</option>,
                                            <option key={18} value={18}>18 Monate</option>,
                                            <option key={24} value={24}>24 Monate</option>,
                                            <option key={30} value={30}>30 Monate</option>,
                                            <option key={36} value={36}>36 Monate</option>,
                                            <option key={42} value={42}>42 Monate</option>,
                                            <option key={48} value={48}>48 Monate</option>,
                                            <option key={54} value={54}>54 Monate</option>,
                                            <option key={60} value={60}>60 Monate</option>,

                                        ]}
                                    </CustomSelect>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="formFieldContent">
                                <div className="fieldDiv">
                                    <CustomCheckbox className="inputField" ref={el => formRefs.current[4] = el}
                                    label="Ich stimme zu, dass meine angegebenen Daten für die Kontaktaufnahme per E-Mail und Telefon sowie für weitere Zwecke, einschließlich der Zusendung von Informationen zu Produkten, Dienstleistungen, Angeboten und Werbeaktionen, verwendet werden dürfen. Mir ist bewusst, dass ich diese Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen kann. *"
                                    name="vor_um" rules={[{ruleKey: "required"}]}/>
                                </div>
                                <div className="fieldDiv">
                                    <CustomCheckbox className="inputField" ref={el => formRefs.current[3] = el}
                                    label={
                                        <>
                                            Ich habe die <a href="https://www.wohnfinanzierung.at/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a> gelesen, verstanden und erkläre mich damit einverstanden, dass meine Daten gemäß den Bestimmungen verarbeitet werden. Mir ist bewusst, dass ich meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen kann.*
                                        </>
                                    }
                                    name="datenschutz" rules={[{ruleKey: "required"}]} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
